export { Partition } from './Partition';
export type { Props } from './Partition.types';
